
import { defineComponent } from 'vue';
import { useEditorProps } from '@/lib/components/Shared/editor/editorProps';
import { useLanguageProps } from '@/lib/components/Shared/editor/languageProps';
import { useController } from '@/domain/services/Composer';
import { ckEditorController, Props, View } from '@/lib/components/Shared/editor/ckeditor/CKEditor.controller';
import { useUploadProps } from '@/lib/components/Shared/editor/uploads/uploadsProps';

export default defineComponent<Props, View>({
	props: {
		...useEditorProps,
		...useLanguageProps,
		...useUploadProps,
	},

	setup: useController(ckEditorController, 'CKEditorController') as () => View,
});
